/* assets/slideshow-a11y.js */
(function () {
  // ---------------- Utilities ----------------
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));

  // Remove aria-* attributes that aren't needed on list items (keeps Lighthouse happy)
  function scrubLiAria(li) {
    if (!li) return;
    li.removeAttribute('role');
    // remove any aria-* added by third-party code
    Array.from(li.attributes).forEach(attr => {
      if (attr.name.startsWith('aria-')) li.removeAttribute(attr.name);
    });
  }

  // Label/normalize the dots list
  function labelDots(dotsUL) {
    if (!dotsUL) return;

    // Dots should never be aria-hidden
    if (dotsUL.getAttribute('aria-hidden') === 'true') dotsUL.removeAttribute('aria-hidden');

    // Use semantic UL/LI only — no ARIA roles needed on list or items
    // (Lighthouse dislikes mismatched ARIA on <li>)
    dotsUL.removeAttribute('role');
    if (!dotsUL.hasAttribute('aria-label')) {
      dotsUL.setAttribute('aria-label', 'Slideshow pagination');
    }

    const items = $$(dotsUL, 'li');
    items.forEach((li, i) => {
      scrubLiAria(li);
      const btn = li.querySelector('button');
      if (!btn) return;
      // Keep native <button> semantics; add label + manage tab order
      if (!btn.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
      }
    });

    syncDotTabbing(dotsUL);

    // Keyboard once
    if (!dotsUL.dataset._a11yKeys) {
      dotsUL.addEventListener('keydown', onDotsKeydown);
      dotsUL.dataset._a11yKeys = '1';
    }
  }

  // Only the active dot is tabbable
  function syncDotTabbing(dotsUL) {
    const items = $$(dotsUL, 'li');
    items.forEach(li => {
      const btn = li.querySelector('button');
      if (!btn) return;
      const active = li.classList.contains('slick-active');
      btn.setAttribute('tabindex', active ? '0' : '-1');
      // Optional: announce current page with aria-current (not required)
      if (active) btn.setAttribute('aria-current', 'page');
      else btn.removeAttribute('aria-current');
    });
  }

  // Keyboard: Left/Right, Home/End for dot navigation
  function onDotsKeydown(e) {
    const tgt = e.target;
    if (!(tgt instanceof HTMLElement) || tgt.tagName !== 'BUTTON') return;

    const dotsUL   = tgt.closest('ul.slick-dots');
    const slideshow = dotsUL && dotsUL.closest('.slideshow');
    if (!dotsUL) return;

    const btns = $$(dotsUL, 'li > button');
    const idx  = btns.indexOf(tgt);
    if (idx === -1) return;

    let nextIdx = null;
    switch (e.key) {
      case 'ArrowLeft':
      case 'Left':
        e.preventDefault();
        nextIdx = (idx - 1 + btns.length) % btns.length;
        break;
      case 'ArrowRight':
      case 'Right':
        e.preventDefault();
        nextIdx = (idx + 1) % btns.length;
        break;
      case 'Home':
        e.preventDefault();
        nextIdx = 0;
        break;
      case 'End':
        e.preventDefault();
        nextIdx = btns.length - 1;
        break;
      default:
        return;
    }

    if (slideshow && window.jQuery && jQuery(slideshow).slick) {
      jQuery(slideshow).slick('slickGoTo', nextIdx);
    } else {
      btns[nextIdx].click();
    }
    btns[nextIdx].focus();
  }

  // Disable/enable focusables within an element (for hidden slides)
  // Make descendants focusable or not
    function setFocusable(root, enable) {
    const focusables = root.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    focusables.forEach(el => {
        if (enable) {
        // restore tabindex if we stored one
        if (el.hasAttribute('data-prev-tabindex')) {
            el.setAttribute('tabindex', el.getAttribute('data-prev-tabindex'));
            el.removeAttribute('data-prev-tabindex');
        } else if (el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
        }
        el.removeAttribute('aria-hidden');
        } else {
        // save and remove from tab order
        if (el.hasAttribute('tabindex')) {
            el.setAttribute('data-prev-tabindex', el.getAttribute('tabindex'));
        }
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
        }
    });
    }

    // Walk up and remove aria-hidden="true" from ancestors (so active UI is visible to AT)
    function unhideAncestors(el, stopAt) {
    let n = el;
    while (n && n !== stopAt) {
        if (n.getAttribute && n.getAttribute('aria-hidden') === 'true') {
        n.removeAttribute('aria-hidden');
        }
        n = n.parentElement;
    }
    }

    // Add this helper
    function sanitizeContainerRoles(slideshowEl) {
    // Slick sometimes injects roles that imply required children (listbox, tablist, row, list, etc.)
    const badRoles = new Set(['listbox', 'tablist', 'row', 'list', 'tabpanel', 'grid', 'table']);
    // Strip roles from slick containers
    const containers = [
        slideshowEl.querySelector('.slick-track'),
        slideshowEl.querySelector('.slick-list')
    ].filter(Boolean);

    containers.forEach(el => {
        const r = el.getAttribute('role');
        if (r && badRoles.has(r)) el.removeAttribute('role');
        // Also remove stray aria-* that hides them incorrectly
        if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
    });

    // Make slides “groups” with a nice label, instead of any table/list roles
    const slides = Array.from(slideshowEl.querySelectorAll('.slick-slide'));
    const total  = slides.length;
    slides.forEach((slide, i) => {
        const r = slide.getAttribute('role');
        if (r && badRoles.has(r)) slide.removeAttribute('role');
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        // Label: “Slide N of M”
        if (!slide.getAttribute('aria-label')) {
        slide.setAttribute('aria-label', `Slide ${i + 1} of ${total}`);
        }
    });
    }


  // Keep only the active slide operable/visible to AT
  function normalizeSlides(slideshowEl) {
    const slides = Array.from(slideshowEl.querySelectorAll('.slick-slide'));

    slides.forEach(slide => {
        const active = slide.classList.contains('slick-active');

        // Only the inactive slides should be aria-hidden
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        setFocusable(slide, active);

        // Clean up odd roles Lighthouse complains about
        const r = slide.getAttribute('role');
        if (r && r !== 'group' && r !== 'region') slide.removeAttribute('role');

        if (active) {
        // Make sure no parent hides the active slide
        unhideAncestors(slide, slideshowEl);
        }
    });

    // Dots/pagination: ensure they are not hidden and are labelled correctly
    const dots = slideshowEl.querySelector('ul.slick-dots');
    if (dots) {
        // some themes add aria-hidden on the dots or their parents — undo it
        unhideAncestors(dots, slideshowEl);

        // give proper roles/labels/tab stops
        labelDots(dots);
    }

    // Any toggle-ish buttons without a name → give a safe fallback label
    Array.from(slideshowEl.querySelectorAll('button[aria-pressed], button[aria-expanded]')).forEach(btn => {
        if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
        btn.setAttribute('aria-label', 'Toggle');
        }
    });

    // Also sanitize slick containers (role/aria-hidden mismatches)
    sanitizeContainerRoles(slideshowEl); // <- call the helper you added earlier
    }


  // Enhance a single slideshow (watch for dots/slide changes)
  function enhanceOne(slideshow) {
    if (!slideshow || slideshow.dataset._a11yInit === '1') return;

    const applyDots = () => {
      const dots = slideshow.querySelector('ul.slick-dots');
      if (dots) labelDots(dots);
    };

    // Initial passes (immediately, next frame, and a little later)
    applyDots();
    normalizeSlides(slideshow);
    requestAnimationFrame(() => { applyDots(); normalizeSlides(slideshow); });
    setTimeout(() => { applyDots(); normalizeSlides(slideshow); }, 400);

    // Observe the slideshow subtree for injected changes
    const mo = new MutationObserver(() => {
      applyDots();
      normalizeSlides(slideshow);
    });
    mo.observe(slideshow, { childList: true, subtree: true });

    slideshow.dataset._a11yInit = '1';
  }

  function enhanceAll(root = document) {
    $$(root, '.slideshow').forEach(enhanceOne);
  }

  // ---------------- Init & Slick Hooks ----------------
  document.addEventListener('DOMContentLoaded', () => enhanceAll(document));
  document.addEventListener('shopify:section:load', (e) => enhanceAll(e.target || document));

  if (window.jQuery) {
    jQuery(document).on('init reInit setPosition afterChange', '.slideshow', function () {
      normalizeSlides(this);
      const dots = this.querySelector('ul.slick-dots');
      if (dots) { labelDots(dots); syncDotTabbing(dots); }
    });
  }
})();
